var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTheorg = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25.25c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    stroke: "#22262A",
    strokeWidth: 0.014,
    d: "M8.491 17.885H5.5v-4.837c0-.626.357-1.188 1.23-1.188h3.565c.665 0 1.21-.7 1.21-1.231V8.613h2.97v2.016c0 .529.708 1.23 1.082 1.23h3.755c.693 0 1.188.774 1.188 1.189v4.837h-3.013v-2.992h-3.012V11.86h-2.97v3.034H8.49z"
  })));
};
export default SvgTheorg;